<template>
  <el-main class="container">
    <el-form
      label-position="top"
      label-width="80px">
      <div class="title" v-if="type === 'set'">编辑场地布局</div>
      <div class="title" v-else>新增场地布局</div>
      <el-form-item label="排序序号">
        <el-input
          v-model.trim="body.indexNum"
          placeholder="请输排序序号"
          clearable
          @mousewheel.native.prevent
          type="number"
          class="width"
          maxlength="100"/>
      </el-form-item>
      <el-form-item label="场地布局名称">
        <el-input
          v-model.trim="body.name"
          placeholder="请输入场地布局名称"
          clearable
          type="text"
          class="width"
          maxlength="100"/>
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <el-button @click="event().goBack()">取消</el-button>
      <el-button type="primary" @click="event().update()">保存</el-button>
    </div>
  </el-main>
</template>

<script>
import { setPlaceLayout, addPlaceLayout } from '@/api/meeting'
export default {
  data() {
    return {
      type: '',
      body: {
        indexNum: '',
        name: '',
        uuid: ''
      }
    }
  },
  created() {
    const { meta } = this.$route
    this.type = meta[meta.length - 1].url
    if (this.type === 'set') {
      Object.assign(this.body, this.$route.query.info.row)
    }
  },
  methods: {
    event() {
      return {
        goBack: () => {
          this.$router.push('/metting-management/place-management')
        },
        update: () => {
          if (!this.handlervarifyBody()) return
          if (this.type === 'set') {
            this.network().setPlaceLayout()
          } else {
            this.network().addPlaceLayout()
          }
        }
      }
    },
    network() {
      return {
        setPlaceLayout: async() => {
          await setPlaceLayout(this.body)
          this.$message({
            type: 'success',
            message: '新增成功'
          })
          this.$router.push('/metting-management/place-management')
        },
        addPlaceLayout: async() => {
          await addPlaceLayout(this.body)
          this.$message({
            type: 'success',
            message: '新增成功'
          })
          this.$router.push('/metting-management/place-management')
        }
      }
    },
    handlervarifyBody() {
      const { body } = this
      if (body.indexNum <= 0) {
        this.$message({
          message: '请填写排序序号',
          type: 'warning'
        })
        return false
      }
      if (!body.name) {
        this.$message({
          message: '请输入场地布局名称',
          type: 'warning'
        })
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.container{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title{
    font-size: 25px;
    margin: 30px 0;
    font-weight: bold;
  }
  .btn-box{
    margin: 30px 0;
    display: flex;
    justify-content: center;
  }
}
</style>
